import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';

import reducers from '~reducers';

const store = configureStore({
	reducer: reducers,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				// Ignore these action types for serialization check
				ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
			},
		}).concat(thunk),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
